export enum STEP_EXTENDED_CAPTATION {
  CONFIRMATION_EXTENDED_CYCLE = 'confirmation-extended-cycle',
  CONFIRMATION_NEW_CYCLE = 'confirmation-new-cycle',
  CHOOSE_CYCLE = 'choose-cycle',
  CHOOSE_EXTENDED_CYCLE = 'choose-extended-cycle',
  CHOOSE_NEW_CYCLE = 'choose-new-cycle',
}
